import $ from 'jquery';

export default {
	init() {
		// console.log(
		// 	'Menu module initialized',
		// 	$('#mobile-menu-toggle'),
		// 	$('.header__desktop-nav'),
		// 	$('#mobile-menu-close'),
		// 	$('.nav-toggle')
		// );
		var menuBreakpoint = 1023;

		// Mobile menu — native <dialog>. showModal() handles focus trapping,
		// background inert, Esc, and the ::backdrop overlay for us.
		var $toggle = $('#mobile-menu-toggle');
		var dialog = document.getElementById('header-mobile-menu');

		// Matches the .hamburger-line transform transition in _header.scss.
		var hamburgerAnimationMs = 260;

		if (dialog && typeof dialog.showModal === 'function') {
			$toggle.on('click', function () {
				// Kick off the hamburger morph first, then fade the dialog in
				// once that animation has finished.
				$toggle.attr('aria-expanded', 'true');

				var reduceMotion =
					window.matchMedia &&
					window.matchMedia('(prefers-reduced-motion: reduce)').matches;

				var openDialog = function () {
					dialog.showModal();
					// Lock background scroll — showModal() inertizes the page but
					// does not stop the document behind from scrolling.
					document.documentElement.classList.add('--dialog-open');
					// Add the fade-in class on the next frame so the opacity
					// transition runs instead of the dialog popping into place.
					window.requestAnimationFrame(function () {
						dialog.classList.add('--open');
					});
				};

				if (reduceMotion) {
					openDialog();
				} else {
					setTimeout(openDialog, hamburgerAnimationMs);
				}
			});

			// Close button inside the dialog.
			$(dialog).on('click', '.header__mobile-close', function () {
				dialog.close();
			});

			// Light-dismiss fallback for browsers without `closedby="any"`:
			// a click landing on the dialog itself (the backdrop) closes it.
			dialog.addEventListener('click', function (event) {
				if (event.target === dialog) {
					dialog.close();
				}
			});

			// Reset toggle + fade + scroll-lock state whenever the dialog closes
			// (button, Esc, or backdrop).
			dialog.addEventListener('close', function () {
				$toggle.attr('aria-expanded', 'false');
				dialog.classList.remove('--open');
				document.documentElement.classList.remove('--dialog-open');
			});
		}

		// Toggle dropdown on button click
		$('.header__dropdown-toggle').on('click', function () {
			var $button = $(this);
			var $dropdownItem = $button.closest('.header__dropdown-item');
			var $dropdownMenu = $dropdownItem.find('.header__dropdown-menu');

			var isExpanded = $button.attr('aria-expanded') === 'true';

			if (isExpanded) {
				// Close this dropdown
				$button.attr('aria-expanded', false);
				$dropdownItem.removeClass('--dropdown-open');
				$dropdownMenu.hide();
			} else {
				// Close all other dropdowns first
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();

				// Open this dropdown
				$button.attr('aria-expanded', true);
				$dropdownItem.addClass('--dropdown-open');
				$dropdownMenu.show();
			}
		});

		// Allow tab navigation for dropdown menu
		// $('.header__dropdown-link').on('focus', function () {
		// 	var $item = $(this).closest('.header__dropdown-item');
		// 	$item.find('.header__dropdown-toggle').attr('aria-expanded', true);
		// 	$item.addClass('--dropdown-open');
		// 	$item.find('.header__dropdown-menu').show();
		// });

		$('.header__dropdown-item').on('focusout', function () {
			var $this = $(this);
			setTimeout(function () {
				if (!$this.find(':focus').length) {
					$this.find('.header__dropdown-toggle').attr('aria-expanded', false);
					$this.removeClass('--dropdown-open');
					$this.find('.header__dropdown-menu').hide();
				}
			}, 100);
		});

		// Close dropdowns when clicking outside
		$(document).on('click', function (event) {
			if (!$(event.target).closest('.header__dropdown-item').length) {
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();
			}
		});

		// Close dropdowns on escape key
		$(document).on('keydown', function (event) {
			if (event.key === 'Escape' || event.keyCode === 27) {
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();
			}
		});

		// Hover functionality for dropdown menus
		$('.header__dropdown-item').on('mouseenter', function () {
			//console.log('mouse entered');
			if ($(window).width() <= menuBreakpoint) {
				return; // Skip hover functionality on mobile
			}
			var $item = $(this);
			var $button = $item.find('.header__dropdown-toggle');
			var $menu = $item.find('.header__dropdown-menu');

			// Close all other dropdowns first
			$('.header__dropdown-item').not($item).removeClass('--dropdown-open');
			$('.header__dropdown-toggle').not($button).attr('aria-expanded', false);
			$('.header__dropdown-menu').not($menu).hide();

			// Open this dropdown
			$button.attr('aria-expanded', true);
			$item.addClass('--dropdown-open');
			$menu.show();
		});

		$('.header__dropdown-item').on('mouseleave', function () {
			//console.log('mouse left');
			if ($(window).width() <= menuBreakpoint) {
				return; // Skip hover functionality on mobile
			}
			var $item = $(this);
			var $button = $item.find('.header__dropdown-toggle');
			var $menu = $item.find('.header__dropdown-menu');

			// Close this dropdown
			$button.attr('aria-expanded', false);
			$item.removeClass('--dropdown-open');
			$menu.hide();
		});

		// On resize up to desktop, close the mobile dialog and any open dropdowns.
		function resizeHandler() {
			if (window.innerWidth > menuBreakpoint) {
				if (dialog && dialog.open) {
					dialog.close();
				}
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();
			}
		}

		$(window).on('resize', function () {
			resizeHandler();
		});
	},
};
